// Membership tier helpers.
export const tierOf = (user) =>
  (user && user.membership_tier) || (user && user.is_premium ? "premium" : "free");

export const isPaid = (user) => ["basic", "premium"].includes(tierOf(user));

export const isPremium = (user) => tierOf(user) === "premium";
